export function getReceiptDiscounts(order = {}) {
    const deliveryCharges = Number(order.packagingCharges || order.financial?.deliveryCharges || 0);
    const couponDiscount = Number(order.razorpay?.couponDiscount || order.financial?.couponDiscount || 0);
    const freeCashDiscount = Number(
        order.razorpay?.freeCashDiscount
        || order.financial?.freeCashDiscount
        || order.freeCashDiscount
        || 0
    );

    return { deliveryCharges, couponDiscount, freeCashDiscount };
}

export function calculateGrandTotalFromItemTotal(itemTotal, order = {}) {
    const { deliveryCharges, couponDiscount, freeCashDiscount } = getReceiptDiscounts(order);
    return itemTotal - couponDiscount - freeCashDiscount + deliveryCharges;
}

export function getFinancialDiscounts(financial = {}) {
    return {
        couponDiscount: Number(financial.couponDiscount || 0),
        freeCashDiscount: Number(financial.freeCashDiscount || 0),
        deliveryCharges: Number(financial.deliveryCharges || 0),
    };
}

export function calculatePayableFromDiscountedTotal(discountedTotal, financial = {}) {
    const { couponDiscount, freeCashDiscount, deliveryCharges } = getFinancialDiscounts(financial);
    return discountedTotal - couponDiscount - freeCashDiscount + deliveryCharges;
}

export function buildFreeCashLoadPayload(form, extra = {}) {
    return {
        ...extra,
        amount: Number(form.amount),
        minCartValue: Number(form.minCartValue || 0),
        expiryDays: Number(form.days || 0),
        expiryHours: Number(form.hours || 0),
        expiryMinutes: Number(form.minutes || 0),
    };
}
